<template>
  <div class="post">
    <div class="avatar"></div>
    <div class="line"></div>
    <br>
    <div class="tags">
      <div class="tag"></div>
      <div class="tag"></div>
      <div class="tag"></div>
      <div class="tag"></div>
      <div class="tag"></div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "SkeletonCard"
    }
</script>

<style scoped lang="sass">

  $base-color: #cecece
  $shine-color: rgba(229,229,229,0.8)
  $animation-duration: 2.0s
  $avatar-offset: 52 + 16

  @mixin background-gradient
    background-image: linear-gradient(90deg, $base-color 0px, $shine-color 40px, $base-color 80px)
    background-size: 600px

  body
    margin: 0

  .container
    height: 100vh
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center

  .post
    width: 100%
    height: 380px
    margin-top: 6px
    border-radius: 3px
    padding: 21px
    background-color: #fff
    position: relative
    overflow: hidden
    border: 1px solid rgba(36, 49, 67, 0.1)

    .avatar
      width: 100%
      background-color: #ccc
      width: 100%
      height: 212px
      margin-bottom: 18px
      border-radius: 3px

      @include background-gradient
      animation: shine-avatar $animation-duration infinite ease-out

    .tags
      display: flex
      margin-top: 12px

    .tag
      width: 140px
      height: 33px
      margin-top: 12px
      margin-right: 5px
      border-radius: 3px
      @include background-gradient
      animation: shine-lines $animation-duration infinite ease-out

    .line
      float: left
      width: 140px
      height: 16px
      margin-top: 12px
      border-radius: 3px
      display: block

      @include background-gradient
      animation: shine-lines $animation-duration infinite ease-out

    .avatar + .line
      margin-top: 11px
      width: 100px

    .line ~ .line
      background-color: #ddd

  @keyframes shine-lines
    0%
      background-position: -100px

    40%, 100%
      background-position: 140px

  @keyframes shine-avatar
    0%
      background-position: -100px + $avatar-offset

    40%, 100%
      background-position: 140px + $avatar-offset

</style>
